import React from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import Navbar from '../../components/shared/Navbar';


const Dashboard = () => {
    const loginMatch = useMatch('/admin');
    return (
        <div>
       {!loginMatch && <Navbar />}
        <Outlet />
    </div>
    );
};

export default Dashboard;